// apiUtils.ts
import { ref, computed } from 'vue';

// Import variables from services to use in components
// import { getResourceUrl, getLevelTechUrl } from '@/services/admin_actions/apiUtils';

// Computed Properties to get the API URLs from environment variables
export const sportTitle = computed(() => import.meta.env.VITE_SPORT_TITLE);
export const sportIdPrefix = computed(() => import.meta.env.VITE_SPORT_TITLE.charAt(0).toLowerCase() + 'lid');

// Computed Properties to get the API URLs from environment variables
export const resourceApiUrl = computed(() => import.meta.env.VITE_RESOURCE_API_URL);
export const levelTechApiUrl = computed(() => import.meta.env.VITE_LEVEL_TECH_API_URL);
export const authUrl = computed(() => import.meta.env.VITE_AUTH_URL);
export const webAppUrl = computed(() => import.meta.env.VITE_WEB_APP_URL);

// General methods to get the full URL by appending the provided path to each base URL
export const getResourceUrl = (path: string): string => `${resourceApiUrl.value}${path}`;
export const getLevelTechUrl = (path: string): string => `${levelTechApiUrl.value}${path}`;
export const getWebAppUrl = (path: string): string => `${webAppUrl.value}${path}`;
export const getAuthUrl = (path: string): string => `${authUrl.value}${path}`;

// Reactive references to track viewport size
export const isMobile = ref(typeof window !== 'undefined' ? window.innerWidth < 767 : false);
export const isTablet = ref(typeof window !== 'undefined' ? window.innerWidth >= 767 && window.innerWidth < 1024 : false);
export const isDesktop = ref(typeof window !== 'undefined' ? window.innerWidth >= 1024 : false);

export const updateViewport = () => {
  if (typeof window !== 'undefined') {
    isMobile.value = window.innerWidth < 767;
    isTablet.value = window.innerWidth >= 767 && window.innerWidth < 1024;
    isDesktop.value = window.innerWidth >= 1024;
  }
};

// Method to get the full image URL, checking if the provided string is already a full URL
export const getImageUrl = (img: string) => {
  if (img.startsWith('http')) {
    return img;
  }
  return getResourceUrl('/' + img);
};
